{
	"showButtonTitle": "Pokaż",
	"hideButtonTitle": "Ukryj"
}
